'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = 'react-flex-v2';


//////////////////
// WEBPACK FOOTER
// ./~/react-flex/lib/prefix.js
// module id = 994
// module chunks = 0